import React from 'react'
import { useInView } from 'react-intersection-observer'
import { useEffect } from 'react';

function Backend() {
    const { ref , inView } = useInView();

    useEffect(()=>{
        if(inView) {
            document.querySelector(".backend").style.transform = "translateX(00px)"
            document.querySelector(".backend").style.opacity = 1;
        }else{
            document.querySelector(".backend").style.transform = "translateX(200px)"
            document.querySelector(".backend").style.opacity = 1;
        }
    },[inView])


  return (
    <div ref={ref} className="skills__content backend">
        <h3 className="skills__title">Backend Developer</h3>
        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                <i className='bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">Mongo DB</h3>
                    <span className="skills__level">Intermidiate</span>
                </div>
                </div>
                <div className="skills__data">
                <i className='bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">Node js</h3>
                    <span className="skills__level">Basic</span>
                </div>
                </div>
                <div className="skills__data">
                <i className='bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">Express JS</h3>
                    <span className="skills__level">Intermidiate</span>
                </div>
                </div>
            </div>


            <div className="skills__group">
                <div className="skills__data">
                <i className='bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">Firebase</h3>
                    <span className="skills__level">Intermidiate</span>
                </div>
                </div>
               
            </div>
        </div>
    </div>
  )
}

export default Backend